/**
 * CollectionsSection
 */

import { getResponsiveAssets } from '../../../../utils/image';
import './styles.scss';

import * as React from 'react';
import * as BEM from 'react-bem-helper';

import CollectionCard from '../../../molecules/media/CollectionCard';
import ScrollableSection, { ScrollableSectionProps } from '../ScrollableSection';
import SectionTitle from '../SectionTitle';

interface ICollectionsSection {
  new (): ScrollableSection<GQL.ICollection | null>;
}

interface CollectionListProps extends Pick<ScrollableSectionProps<GQL.ICollection | null>, 'data'> {
  gridView?: boolean;
  hideTitle?: boolean;
}

const CollectionsSection = ScrollableSection as ICollectionsSection;

const classes = new BEM('collection-list');

export default function Collections(props: CollectionListProps) {
  return !!props.data.length ? props.gridView ? (
    <div {...classes('', 'grid-view')}>
      <div {...classes('content-wrapper', '', 'container')}>
        {!props.hideTitle && <SectionTitle title="Collections" subtitle="Popular" {...classes('title') } />}
        <ul {...classes('list')}>
          {props.data.map((item) => item ? (
            <li  {...classes('list__item')} key={`collection-${item.slug}`}>
              <CollectionCard
                image={getResponsiveAssets('cover', item.assets!)}
                subtitle={item.category ? item.category.name! : 'Collection'}
                title={item.name}
                slug={item.slug!}
                size="vertical"
              />
            </li>
          ) : null)}
        </ul>
      </div>
    </div>
  ) : (
    <CollectionsSection
      className="collection-list"
      id="collections"
      title="Collections"
      subtitle="Popular"
      {...props}
    >{(item, index) => item ? (
      <CollectionCard
        image={getResponsiveAssets('cover', item.assets!)}
        subtitle={item.category ? item.category.name! : 'Collection'}
        title={item.name}
        slug={item.slug!}
        size="vertical"
      />
    ) : null}
    </CollectionsSection>
  ) : null;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/content/Collections/index.tsx